import type { FaireProductEntity } from "../../entity_types/product";

export const p_5mgged7qpz: FaireProductEntity = {
  token: "p_5mgged7qpz",
  type: "product",
  name: "Woo Pig Funky",
  brandToken: "b_gsury7wafe",
  brandName: "JB Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/7950a1b3c9077302c9e27a3110f7bde2a30cf9c8e797523200750e5f1f92efb7.jpeg",
  galleryImageUrls: [],
  priceDollars: 28,
  description:
    'Introducing Woo Pig Funky, the bold and vibrant sweatshirt/tee that will make you stand out from the crowd. With its funky, bright colors and iconic "Woo pig Sooie" design, this is the perfect choice for game day or any occasion. Show off your team spirit in style and feel confident in its eye-catching appeal. Own the look of a true fan.\n',
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:00.267Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
